<template>
  <div class="dropdown-menu-type-1">
    <div class="__box">
      <button @click.stop="show" v-text="tempTitle"></button>
      <ul ref="idDropdown" class="dropdown-box">
        <li
          v-for="(item, key) in tempData"
          v-bind:key="key"
          :style="{ display: item.title !== 'All' ? '' : 'none' }"
          @click="selectMenu(key)"
          :class="{ 'active-item': tempIndex === key }"
        >
          {{ item.title }}
        </li>
      </ul>
    </div>
    <button type="button" class="__go__button" @click.stop="goToPage">
      <span>GO</span>
    </button>
  </div>
</template>
<script>
export default {
  name: 'dropdown-menu-type-1',
  props: {
    title: {
      default: 'Choose event type',
      type: String
    },
    data: {
      default: () => ({
        '5BZaLDw4JW2sStegkGss': {
          title: 'Street'
        }
      }),
      type: [Array, Object]
    },
    index: {
      default: 'Lrzxub4vvDSbljcI7mst',
      type: String
    },
    location: {
      default: '',
      type: String
    }
  },
  data() {
    return {
      tempTitle: '',
      tempIndex: this.index,
      tempBaseUrl: ''
    }
  },
  created() {
    this.tempTitle = this.title
  },
  computed: {
    tempData() {
      return this.data
    }
  },
  methods: {
    generateBaseUrl() {
      if (this.tempBaseUrl.indexOf(this.location)) {
        this.tempBaseUrl =
          '/main?speciality=' + this.tempIndex + '&city=' + this.location
      } else {
        this.tempBaseUrl = '/main?speciality=' + this.tempIndex
      }
    },
    /**
     * Click the button to display the corresponding child elements.
     * @param event
     */
    show() {
      const el = this.$refs.idDropdown // Binding child element.
      if (el.className === 'dropdown-box') {
        el.className += ' active'
      } else {
        el.className = 'dropdown-box'
      }
    },
    selectMenu(key) {
      this.tempTitle = this.data[key].title
      this.tempIndex = key
      this.$emit('model', key)
    },
    goToPage() {
      this.generateBaseUrl()
      console.log(this.tempBaseUrl)
      this.$router.push({ path: this.tempBaseUrl })
    }
  },
  watch: {
    location(newValue) {
      console.log('location:', newValue)
      if (newValue === null) {
        this.tempIndex = ''
        this.tempTitle = 'Choose event type'
      } else if (newValue) {
        this.tempBaseUrl = '?speciality=' + this.tempIndex + '&city=' + newValue
        console.log('this.tempBaseUrl:', this.tempBaseUrl)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dropdown-menu-type-1 {
  // Actions to prevent other stylesheets from affecting.
  text-align: left;
  display: flex;
  flex-flow: row nowrap;
  position: relative;

  button {
    cursor: pointer;
    border: 0;
    outline: none;
  }

  .__box {
    height: 60px;
    width: 250px;
    background-color: rgba(255, 255, 255, 0.46);

    button {
      background-color: rgba(0, 0, 0, 0.3);
      background-image: url('../../assets/images/down-arrow.svg');
      background-position-y: 28px;
      background-position-x: 220px;
      background-repeat: no-repeat;
      width: inherit;
      height: inherit;
      padding-left: 20px;
      text-align: left;
      font-size: 16px;
      font-weight: 200;
      letter-spacing: 1px;
      color: #ffffff;

      font-family: Poppins;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
    }

    //noinspection ALL
    .dropdown-box {
      overflow: hidden;
      height: 0;
      z-index: -1;
      background-color: rgba(0, 0, 0, 0.32);
      width: inherit;
      position: absolute;
      margin-top: 2px;
      list-style: none;
      color: white;
      opacity: 0;
      visibility: hidden;
      padding: 10px 0;

      transition-property: width height background-color font-size left top
        transform transform color;
      transition-duration: 0.3s;
      transition-timing-function: ease-in-out;

      li {
        cursor: pointer;
        line-height: 30px;
        padding-left: 20px;
      }

      li:hover {
        color: black;
        background-color: white;

        transition-property: background-color transform transform color;
        transition-duration: 0.3s;
        transition-timing-function: ease-in-out;
      }

      .active-item {
        color: black;
        background-color: white;
      }
    }

    //noinspection ALL
    .active {
      height: auto;
      z-index: 1000;
      opacity: 1;
      visibility: visible;

      -webkit-transition-property: width height background-color font-size left
        top transform -webkit-transform color;
      -webkit-transition-duration: 0.3s;
      -webkit-transition-timing-function: ease-in-out;

      -moz-transition-property: width height background-color font-size left top
        transform -moz-transform color;
      -moz-transition-duration: 0.3s;
      -moz-transition-timing-function: ease-in-out;

      -ms-transition-property: width height background-color font-size left top
        transform -ms-transform color;
      -ms-transition-duration: 0.3s;
      -ms-transition-timing-function: ease-in-out;

      -o-transition-property: width height background-color font-size left top
        transform -o-transform color;
      -o-transition-duration: 0.3s;
      -o-transition-timing-function: ease-in-out;

      transition-property: width height background-color font-size left top
        transform transform color;
      transition-duration: 0.3s;
      transition-timing-function: ease-in-out;
    }

    display: inline;
  }

  .__go__button {
    margin: 0 0 0 10px;
    width: 70px;
    height: 60px;
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;

    background-color: #0f00ff;
    text-align: center;

    span {
      line-height: 60px;
      font-size: 20px;
      font-weight: 600;
      letter-spacing: 1.3px;
      color: #ffffff;
    }
  }
}
</style>
